// The error message that comes back from the server needs to be trimmed
export const cleanErrorMessage = (errorMessage: string | undefined) => {
  let message = errorMessage?.substring(22);
  if (message) {
    return message.charAt(0).toUpperCase() + message.slice(1);
  }
};
